import VehiculeDetailController from './vehicule.detail.controller';

export default {
    template: require('./vehicule.detail.html'),
    controller: VehiculeDetailController
};
